import { render, staticRenderFns } from "./BaseRichTextEditor.vue?vue&type=template&id=f743c79e&scoped=true&"
import script from "./BaseRichTextEditor.vue?vue&type=script&lang=js&"
export * from "./BaseRichTextEditor.vue?vue&type=script&lang=js&"
import style0 from "./BaseRichTextEditor.vue?vue&type=style&index=0&id=f743c79e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f743c79e",
  null
  
)

export default component.exports